var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgPenTool = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pen-tool-16px"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.802693 0.80367C0.987442 0.61892 1.25502 0.543632 1.509 0.604938L11.1757 2.93827C11.4596 3.0068 11.6779 3.23388 11.7351 3.52025L12.4856 7.27266C12.7323 7.21166 13.0039 7.27755 13.1967 7.47034L15.1967 9.47034C15.4896 9.76323 15.4896 10.2381 15.1967 10.531L10.53 15.1977C10.2371 15.4906 9.76225 15.4906 9.46936 15.1977L7.46936 13.1977C7.27658 13.0049 7.21068 12.7333 7.27168 12.4866L3.51927 11.7361C3.2329 11.6788 3.00582 11.4605 2.93729 11.1766L0.603961 1.50998C0.542656 1.256 0.617944 0.988419 0.802693 0.80367ZM8.41985 11.1865L11.1855 8.42083L10.3582 4.28402L3.7482 2.68851L6.48859 5.42891C6.7467 5.31433 7.03243 5.25067 7.33302 5.25067C8.48362 5.25067 9.41636 6.18341 9.41636 7.334C9.41636 8.48459 8.48362 9.41733 7.33302 9.41733C6.18243 9.41733 5.24969 8.48459 5.24969 7.334C5.24969 7.0334 5.31335 6.74768 5.42793 6.48957L2.68754 3.74917L4.28305 10.3592L8.41985 11.1865ZM6.91243 6.9298C6.81165 7.03464 6.74969 7.17708 6.74969 7.334C6.74969 7.65617 7.01086 7.91733 7.33302 7.91733C7.65519 7.91733 7.91636 7.65617 7.91636 7.334C7.91636 7.01183 7.65519 6.75067 7.33302 6.75067C7.17611 6.75067 7.03366 6.81262 6.92882 6.91341C6.92613 6.91617 6.92342 6.91893 6.92069 6.92166C6.91795 6.9244 6.9152 6.92711 6.91243 6.9298ZM9.06035 12.6673L9.99969 13.6067L13.6057 10.0007L12.6664 9.06133L9.06035 12.6673Z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPenTool, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pen-tool.5726b520.svg";
export { ForwardRef as ReactComponent };